import React, { useContext, useEffect, useState } from "react";
import LoadingAction from "../../../../../themes/LoadingAction/LoadingAction";
import "./DashboardColaborador.css";
import { Button, Table, Input, Select } from "antd";
import { AuthContext } from "../../../../../contexts/AuthContext";
import { Link, useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import { useParams } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { DatePicker } from "antd";
import "antd/dist/antd.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import * as links from "../../../../../utils/links";
import {
  AiFillFilePdf,
  AiFillDelete,
  AiFillDollarCircle,
} from "react-icons/ai";
import qr_code_icon from "../../../../../assets/images/QR.png";
import notes from "../../../../../assets/images/notes.png";
import jsPDF from "jspdf";
import QRCode from "qrcode";
import { SERVIDOR_URL } from "../../../../../utils/constants";


const DashboardColaborador = (props) => {
  const { Option } = Select;
  const location = useLocation();
  // const { maquinaInfos, clienteInfo } = (location.state as any);

  const { setDataUser, authInfo, setNotiMessage } = useContext<any>(AuthContext);
  const { dataUser } = authInfo;

  let navigate = useNavigate();
  const token = authInfo?.dataUser?.token;
  let currentDate = moment();

  const initialData = {
    colaboradorId: authInfo.dataUser?.id,
    tipo: "",
    operadora: "BALCAO",
    mercadoPagoId: "CASH",
    valor: 0,
    cupom: "",
    placa: "",
    qtdLitro: 0,
  };

  const [data, setData] = useState<any>(initialData);

  const [errors, setErrors] = useState<any>({});
  const [isLoading, setIsLoading] = useState<any>(false);
  const handleChange = (name, value) => {
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => {
      let errorsTemp = { ...prev };
      delete errorsTemp[name];
      return errorsTemp;
    });
  };

  const [searchText, setSearchText] = useState<any>("");
  const [listCanals, setListCanals] = useState<any>([]);
  const [loadingTable, setLoadingTable] = useState<any>(false);
  const [dataInicio, setDataInicio] = useState<any>(null);
  const [dataFim, setDataFim] = useState<any>(null);

  // const []
  const { id } = useParams();
  const { RangePicker } = DatePicker;

  useEffect(() => {
    getData(dataUser?.id);
  }, [dataUser?.id, token]);

  const getData = (id) => {
    const collaboratorId = typeof id === "string" ? id.trim() : "";
    if (collaboratorId !== "" && token) {
      setLoadingTable(true);
      axios
        .get(`${SERVIDOR_URL}/pagamentos-chuveiro/${collaboratorId}`, {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        })
        .then((res) => {
          console.log(res);
          setLoadingTable(false);
          setListCanals(res.data.pagamentos)
        })
        .catch((err) => {
          setLoadingTable(false);
          if ([401, 403].includes(err.response?.status)) {
            // setNotiMessage('A sua sessão expirou, para continuar faça login novamente.');
            setNotiMessage({
              type: "error",
              message:
                "A sua sessão expirou, para continuar faça login novamente.",
            });
            if (dataUser?.key === 'ADMIN') {
              navigate(links.ADMIN_SIGNIN)
              setDataUser(null);
            } else {
              navigate(links.COLABORADOR_SIGNIN)
              setDataUser(null);
            }
          }
        });
    }
  };

  const onSave = () => {
    console.log(data)
    let errorsTemp: any = {};
    if (!dataUser?.id || !token) {
      setNotiMessage({
        type: "error",
        message: "Sua sessão não está completa. Entre novamente para continuar.",
      });
      navigate(links.COLABORADOR_SIGNIN);
      return;
    }
    if (!data.tipo) {
      errorsTemp.tipo = "Escolha o tipo de pagamento aceito";
    }
    if (data.tipo != 'cortesia') {
      if (!data.valor) {
        errorsTemp.valor = "O valor deve ser maior que 0 (zero)";
      }
    }

    if (data.tipo === 'cortesia') {
      if (String(data.placa ?? "").trim() === "") {
        errorsTemp.placa = "Digite a placa do automóvel";
      }
      if (String(data.cupom ?? "").trim() === "") {
        errorsTemp.cupom = "Digite o cupom fiscal";
      }
      if (data.qtdLitro === 0) {
        errorsTemp.qtdLitro = "Digite a quantidade de litros ";
      }
    }

    if (Object.keys(errorsTemp).length > 0) {
      setErrors(errorsTemp);
      return;
    }

    setIsLoading(true);
    axios.post(
      `${SERVIDOR_URL}/pagamento-chuveiro`,
      {
        colaboradorId: data.colaboradorId,
        mercadoPagoId: data.mercadoPagoId,
        operadora: data.operadora,
        tipo: data.tipo,
        valor: data.tipo === 'cortesia' ? authInfo.dataUser?.valorCortesia?.toString() : data.valor,
        maquinaId: "pendente",
        placa: data.placa,
        cupom: data.cupom,
        qtdLitro: data.qtdLitro
      },
      {
        headers: {
          "x-access-token": token,
          "content-type": "application/json",
        },
      }
    ).then((res) => {
      setIsLoading(false);
      getData(authInfo.dataUser?.id);
      setData({
        ...initialData,
        colaboradorId: authInfo.dataUser?.id,
      });
    
      setErrors({});
    }).catch((err) => {
      setIsLoading(false);

      setNotiMessage({
        type: "error",
        message: err.response?.data?.error
          ? err.response?.data?.error
          : `A sua sessão expirou, para continuar faça login novamente.`,
      });
    });
  };

  async function gerarQRCode(valor) {
    try {
      const qrBase64 = await QRCode.toDataURL(valor);
      return qrBase64;
    } catch (err) {
      console.error(err);
      return null;
    }
  }

  async function gerarPDFComQR(comprovante) {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: [58, 90]
    });
    const centerX = 29;

    var pagamento
    if (comprovante.tipo === "bank_transfer") {
      pagamento = "Pix"
    }
    if (comprovante.tipo === "CASH") {
      pagamento = "Especie"
    }
    if (comprovante.tipo === "debit_card") {
      pagamento = "Débito"
    }
    if (comprovante.tipo === "credit_card") {
      pagamento = "Crédito"
    }
    if (comprovante.tipo === "cortesia") {
      pagamento = "Cortesia"
    }

    doc.setLineHeightFactor(1.4);
    doc.setFontSize(8);

    let y = 10;

    // 🔹 CENTRALIZADOS
    doc.setFont("helvetica", "bold");
    doc.text("Credito Chuveiro", centerX, y, { align: "center" });
    y += 5;

    doc.setFont("helvetica", "normal");
    doc.text("Ticket para chuveiros", centerX, y, { align: "center" });
    y += 7;

    // 🔹 BLOCO NORMAL
    const conteudo = [
      `Emissao: ${moment(comprovante?.data).format('DD/MM/YYYY - HH:mm')}`,
      `Creditos: ${comprovante.valor}`,
      `Pagamento: ${pagamento}`,
      `Total: ${pagamento === 'Cortesia' ? 'R$0,00' : 'R$ ' + comprovante.valor}`,
      ""
    ];

    const linhas = doc.splitTextToSize(conteudo as any, 54);

    doc.text(linhas, 2, y);
    y += linhas.length * 2;

    const qrCode = await QRCode.toDataURL(comprovante.valor);

    // posição centralizada
    doc.addImage(qrCode, "PNG", 2, y, 50, 50);

    y += 50;

    doc.text("Escaneie no chuveiro para usar", 29, y, { align: "center" });

    // 📄 salvar
    // doc.save("recibo.pdf");
    const blob = doc.output("blob");
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  }

  function gerarPDF(comprovante) {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: [58, 200]
    });

    const centerX = 29;

    doc.setLineHeightFactor(1.4);
    doc.setFontSize(8);

    let y = 10;

    // 🔹 CENTRALIZADOS
    doc.setFont("helvetica", "bold");
    doc.text("Credito Chuveiro", centerX, y, { align: "center" });
    y += 5;

    doc.setFont("helvetica", "normal");
    doc.text("Ticket para chuveiros", centerX, y, { align: "center" });
    y += 7;

    // 🔹 BLOCO NORMAL
    const conteudo = [
      ".",
      ".",
      `Emissao: ${moment(comprovante?.data).format('DD/MM/YYYY - HH:mm')}`,
      `Creditos: ${comprovante.valor}`,
      `Pagamento: ${comprovante.valor}`,
      `Total: ${comprovante.valor}`,

      ".",
      ""
    ];

    const linhas = doc.splitTextToSize(conteudo as any, 54);

    doc.text(linhas, 2, y);
    y += linhas.length * 4;
    // doc.text(`${maquinaInfos?.nome || ""}`, centerX, y, {
    //   align: "center"
    // });

    // doc.save("qrcodepagamento.pdf");
  }


  const columns = [
    {
      title: "Data",
      dataIndex: "data",
      key: "data",
      render: (data) => (
        <span>{moment(data).format("DD/MM/YYYY HH:mm:ss")}</span>
      ),
    },
    {
      title: "Pagamento",
      dataIndex: "tipo",
      key: "tipo",
      render: (tipo, record) => (
        <span>
          {tipo === "bank_transfer"
            ? "PIX"
            : tipo === "CASH"
              ? "Especie"
              : tipo === "debit_card"
                ? "Débito"
                : tipo === "credit_card"
                  ? "Crédito"
                  : "Cortesia"}
        </span>
      ),
    },
    {
      title: "Cupom",
      dataIndex: "cupom",
      key: "cupom",
    },
    {
      title: "Placa",
      dataIndex: "placa",
      key: "placa",
    },
    {
      title: "Qtd Litros",
      dataIndex: "qtdLitro",
      key: "qtdLitro",
      render: (qtdLitro) => (
        <span>{qtdLitro} L</span>
      )
    },
    {
      title: "Valor",
      dataIndex: "valor",
      key: "valor",
      render: (valor) =>
        new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(valor),
    },
    {
      title: "Créditos",
      dataIndex: "valor",
      key: "valor",
    },
    {
      title: "Status",
      dataIndex: "maquinaId",
      key: "maquinaId",
      width: 100,
      render: (maquinaId, record) =>
        maquinaId ? (
          <span style={{ color: "green", cursor: "pointer" }}>
            {"Creditado"}
          </span>
        ) : (
          <span style={{ color: "gray" }}>
            {"Pendente"}
          </span>
        ),
    },
    {
      title: "Imprimir",
      dataIndex: "id",
      key: "id",
      width: 100,
      render: (id, row) =>
        <Button
          onClick={() => {
            gerarPDFComQR(row)
          }}
          className="PagamentosSearch_header_editBtn"
          style={{ padding: "20px 12px", borderRadius: "8px", gap: "5px" }}
        >
          <AiFillFilePdf />
        </Button>
    },
  ];

  const onRelatorioHandler = () => {
    if (!dataInicio && !dataFim) {
      setNotiMessage({
        type: "error",
        message:
          "Selecione no calendario a esquerda a data de inicio e firm para gerar o relatorio para essa maquina!",
      });
    } else {
      // navigate(`${links.RELATORIO_ADMIN}/${id}`, {
      //   state: { maquinaInfos, clienteInfo, dataInicio, dataFim },
      // });
    }
  };

  const onRelatorioDispHandler = () => {
    // navigate(`${links.RELATORIO_DISP_ADMIN}/${id}`, {
    //   state: { maquinaInfos, clienteInfo, dataInicio, dataFim },
    // });
  };

  return (
    <div className="px-page">
      {isLoading && <LoadingAction />}
      <div className="px-page-header">
        <h1 className="px-page-title">
          Bem vindo, {authInfo.dataUser?.nome}
        </h1>
      </div>

      <div className="px-panel">
        <div className="px-panel-header">
          <h2 className="px-panel-title">Gerar crédito aos chuveiros</h2>
        </div>

        <form
          className="px-form-grid"
          onSubmit={(e) => {
            e.preventDefault();
            if (!isLoading) onSave();
          }}
        >
          <div className={`px-field ${errors.tipo ? "px-field-error" : ""}`}>
            <label className="px-field-label" htmlFor="tipo">
              Tipo de pagamento
            </label>
            <Select
              value={data.tipo || undefined}
              placeholder="Escolha o tipo de Pagamento"
              onChange={(value) => handleChange("tipo", value)}
            >
              {authInfo.dataUser?.permissao === 'VENDA' ?
                <>
                  <Option value="CASH">Dinheiro</Option>
                  <Option value="credit_card">Cartão de Crédito</Option>
                  <Option value="debit_card">Cartão de Débito</Option>
                </>
                : authInfo.dataUser?.permissao === 'VENDACORTESIA' ?
                  <>
                    <Option value="CASH">Dinheiro</Option>
                    <Option value="credit_card">Cartão de Crédito</Option>
                    <Option value="debit_card">Cartão de Débito</Option>
                    <Option value="cortesia">Cortesia</Option>
                  </>
                  :
                  <Option value="cortesia">Cortesia</Option>
              }
            </Select>
            {errors.tipo && (
              <div className="px-field-msg">{errors.tipo}</div>
            )}
          </div>

          {data.tipo && data.tipo === "cortesia" ? (
            <div className="px-field">
              <label className="px-field-label">Valor da Cortesia</label>
              <div className="px-field-static">
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(Number(authInfo.dataUser?.valorCortesia || 0))}
              </div>
            </div>
          ) : (
            <div className={`px-field ${errors.valor ? "px-field-error" : ""}`}>
              <label className="px-field-label" htmlFor="valor">
                Valor *
              </label>
              <Input
                placeholder={"0,00"}
                value={data.valor}
                id="valor"
                type="text"
                name="valor"
                autoComplete="valor"
                onChange={(event) => {
                  handleChange("valor", event.target.value);
                }}
              />
              {errors.valor && (
                <div className="px-field-msg">{errors.valor}</div>
              )}
            </div>
          )}

          {data.tipo === 'cortesia' ? (
            <>
              <div className={`px-field ${errors.cupom ? "px-field-error" : ""}`}>
                <label className="px-field-label" htmlFor="cupom">
                  Cupom *
                </label>
                <Input
                  placeholder={"Cupom fiscal"}
                  value={data.cupom}
                  id="cupom"
                  type="text"
                  name="cupom"
                  autoComplete="cupom"
                  onChange={(event) => {
                    handleChange("cupom", event.target.value);
                  }}
                />
                {errors.cupom && (
                  <div className="px-field-msg">{errors.cupom}</div>
                )}
              </div>
              <div className={`px-field ${errors.placa ? "px-field-error" : ""}`}>
                <label className="px-field-label" htmlFor="placa">
                  Placa *
                </label>
                <Input
                  placeholder={"Placa do Automóvel , Moto"}
                  value={data.placa}
                  id="placa"
                  type="text"
                  name="placa"
                  autoComplete="placa"
                  onChange={(event) => {
                    handleChange("placa", event.target.value);
                  }}
                />
                {errors.placa && (
                  <div className="px-field-msg">{errors.placa}</div>
                )}
              </div>
              <div className={`px-field ${errors.qtdLitro ? "px-field-error" : ""}`}>
                <label className="px-field-label" htmlFor="qtdLitro">
                  Qtd Litros *
                </label>
                <Input
                  placeholder={"0,00"}
                  value={data.qtdLitro}
                  id="qtdLitro"
                  type="text"
                  name="qtdLitro"
                  autoComplete="qtdLitro"
                  onChange={(event) => {
                    handleChange("qtdLitro", event.target.value);
                  }}
                />
                {errors.qtdLitro && (
                  <div className="px-field-msg">{errors.qtdLitro}</div>
                )}
              </div>
            </>
          ) : null}
        </form>

        <div className="px-form-actions">
          <Button
            className="px-btn px-btn-primary"
            onClick={() => {
              if (!isLoading) onSave();
            }}
            disabled={isLoading}
          >
            Gerar Crédito
          </Button>
        </div>
      </div>

      <div className="px-panel">
        <div className="px-panel-header">
          <h2 className="px-panel-title">Créditos gerados</h2>
        </div>
        <div className="px-table-wrap">
          <Table
            columns={columns}
            dataSource={listCanals}
            pagination={{ defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ["10", "20", "50"] }}
            loading={loadingTable}
            locale={{
              emptyText:
                searchText.trim() !== "" ? (
                  "-"
                ) : (
                  <div>Não foram encontrados resultados para sua pesquisa.</div>
                ),
            }}
          />
        </div>
      </div>
    </div>
  );

};

export default DashboardColaborador;
